import React from "react";
import Skeleton from "react-loading-skeleton";

function CardRdvSkeleton() {
  return (
      <div className="col-6">
        <div className="frame-demande">
          <div className="d-flex justify-content-between align-items-start mb-16">
            <div>
              <h5 className="mrb-4">
                <Skeleton width={120} height={20} />
              </h5>
              <p className="body">
                <Skeleton width={180} height={15} />
              </p>
            </div>
            <Skeleton width={24} height={24} circle />
          </div>

          <p className="body bold500 mb-8">
            <Skeleton width={220} height={15} />
          </p>

          <p className="body bold500 mb-8">
            <Skeleton width={180} height={15} />
          </p>

          <div className="d-flex justify-content-between">
            <Skeleton width={`100%`} height={15} />
          </div>

          <div className="row mt-28">
            <div className="col">
              <Skeleton height={40} />
            </div>
            <div className="col">
              <Skeleton height={40} />
            </div>
          </div>
        </div>
      </div>
  );
}

export default CardRdvSkeleton;
